import { FC } from 'react';

import GenericLayout from '../../components/generic-layout/GenericLayout';
import PageImage from '../../components/page-image/PageImage';
import { PageImageId } from '../../components/page-image/type';
import Beschreibung from './Beschreibung';
import Features from './Features';
import Gegensaetze from './Gegensaetze';
import Prinzipien from './Prinzipien';
import Schwerkraft from './Schwerkraft';
import Selbstverteidigung from './Selbstverteidigung';
import WasDuBist from './WasDuBist';

const KnowledgeBase: FC = () => (
  <GenericLayout title='Kampfkunst'>
    <PageImage id={PageImageId.Kampfkunst} />
    <Gegensaetze />
    <Beschreibung />
    <WasDuBist />
    <Features />
    <Schwerkraft />
    <Prinzipien />
    <Selbstverteidigung />
  </GenericLayout>
);

export default KnowledgeBase;
